import { t } from '@/libs/i18n';
import ApplicationController from './application_controller';

const CDN_BASE = 'https://unpkg.com/swagger-ui-dist';

export default class extends ApplicationController {
  async connect() {
    const url = this.element.dataset.openapiUrl;
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    const spec = await response.json();

    const paths = spec.paths || {};
    if (Object.keys(paths).length === 0) {
      this.#mostrarSinAcceso();
      return;
    }

    await this.#cargarSwaggerUI();

    window.SwaggerUIBundle({
      spec,
      domNode: this.element.querySelector('[data-swagger-container]'),
      presets: [window.SwaggerUIBundle.presets.apis],
      layout: 'BaseLayout',
    });
  }

  #mostrarSinAcceso() {
    const container = this.element.querySelector('[data-swagger-container]');
    const msg = document.createElement('div');
    msg.className = 'alert alert-info';
    msg.textContent = t('sin_acceso_api_paths');
    container.replaceWith(msg);
  }

  // eslint-disable-next-line class-methods-use-this
  async #cargarSwaggerUI() {
    if (window.SwaggerUIBundle) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${CDN_BASE}/swagger-ui.css`;
    document.head.appendChild(link);

    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `${CDN_BASE}/swagger-ui-bundle.js`;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}
